/* 封装axios用于发送请求 */
import axios from 'axios'// yarn add axios
import { Toast } from 'vant'
import store from '@/store'

// =========================== Axios 实例 开始 ===========================
// https://www.axios-http.cn/docs/instance
// 1. 修改基地址 https://apifox.com/apidoc/shared-12ab6b18-adc2-444c-ad11-0e60f5693f66/doc-2221080
// 2. 超时 5000
// 3. headers 删除

const instance = axios.create({
  baseURL: 'http://cba.itlike.com/public/index.php?s=/api/',
  timeout: 5000
})

// =========================== Axios 实例 结束 ===========================

// 自定义配置 - 请求/响应 拦截器

// =========================== 拦截器 开始 ===========================
// https://www.axios-http.cn/docs/interceptors
// 1. axios ===> instance
// 2. 响应拦截器  return response.data（默认axios会多包装一层data）
// 3. 响应拦截器 统一处理错误提示
// 4. 请求拦截器 loading 效果
// 5. 响应拦截器 关闭 loading
// 6. 请求拦截器 token

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  if (window.location.href.startsWith('https')) {
    alert('请把 URL 改为 http:// 来访问，否则无法正常请求后端数据')
  }
  // 在发送请求之前做些什么
  // ------- loading -------
  Toast.loading({
    message: '请求中...',
    forbidClick: true,
    loadingType: 'spinner',
    duration: 0
  })
  // ------- loading -------
  // ------- token -------
  const token = store.getters.token
  if (token) {
    config.headers['Access-Token'] = token
    config.headers.platform = 'H5'
  }
  // ------- token -------
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么

  // ------- 响应拦截器  return response.data（默认axios会多包装一层data）
  // return response.data
  // ------- 响应拦截器  return response.data（默认axios会多包装一层data）

  // ------- 统一处理错误提示 -------
  const res = response.data
  if (res.status !== 200) {
    Toast(res.message)
    return Promise.reject(res.message)
  } else {
    Toast.clear()// 清除 loading 中的效果
  }
  return res
  // ------- 统一处理错误提示 -------
}, function (error) {
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么
  return Promise.reject(error)
})

// =========================== 拦截器 结束 ===========================

// 导出配置好的实例
export default instance
